import React, { createContext, useContext, useState, useEffect } from 'react';

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    const stored = localStorage.getItem('bloomwish_wishlist');
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem('bloomwish_wishlist', JSON.stringify(ids));
  }, [ids]);

  const isWishlisted = (id) => ids.includes(id);
  const toggleWishlist = (id) => setIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const removeFromWishlist = (id) => setIds(prev => prev.filter(x => x !== id));

  return (
    <WishlistContext.Provider value={{ ids, isWishlisted, toggleWishlist, removeFromWishlist, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
